import enTranslation from "../i18n/en";
import arTranslation from "../i18n/ar";
const translationsConfig = [
  "$translateProvider",
  function ($translateProvider) {
    $translateProvider
      .translations("en", enTranslation)
      .translations("ar", arTranslation)
      .preferredLanguage("en");
  },
];
export default translationsConfig;



// WEBPACK FOOTER //
// ./src/core/translationConfigs.js